import {
    getApiErrorMessage,
    getFormMode,
    getRecordFromResponse,
    getResponseData,
    validateSchemaFields
} from 'lib/formUtils';
import {
    Box,
    CardContent,
    FormControl,
    TextField,
    Typography
} from '@material-ui/core';
import api from 'services/api';
import PropTypes from 'prop-types';
import { ANAO, ASIM } from 'consts';
import React, { Component } from 'react';
import { AlertInformation } from 'components';
import { safeSetState } from 'lib/reactUtils';
import { ComboPadrao, FormActions, FormStatusSwitch } from 'views/Components';

class SubclassificacaoForm extends Component {
    _isMounted = false;
    safeSetState = safeSetState;

    state = {
        isNewRecord: false,
        isView: false,
        subclassificacao: {
            idsubclassifatendsac: '',
            idclassifatendimento: '',
            descsubclassificacao: '',
            inativo: ANAO
        },
        classificacoes: [],
        openAlert: false,
        messageAlert: '',
        errors: {},
        schema: {
            descsubclassificacao: {
                presence: {
                    allowEmpty: false,
                    message: 'Descrição da subclassificação obrigatória'
                },
                length: { maximum: 100 },
                type: 'string'
            }
        }
    };

    /* Carrega os dados iniciais da tela */
    async componentDidMount() {
        this._isMounted = true;

        const {
            id,
            isNewRecord,
            isView
        } = getFormMode(this.props.match, this.props.location);

        try {
            if (isNewRecord) {
                const classificacoes = await this.loadClassificacoes();

                this.safeSetState({
                    isNewRecord: true,
                    isView: false,
                    subclassificacao: this.getSubClassificacaoDefault(),
                    classificacoes
                });

                return;
            }

            if (!isNaN(Number(id))) {
                await this.loadSubClassificacao(id, isView);
            }
        } catch (error) {
            console.error(
                'Erro ao carregar a subclassificação de atendimento:',
                error.response?.data || error.message
            );

            this.handleOpenAlert(
                getApiErrorMessage(
                    error,
                    'Erro ao carregar a subclassificação de atendimento!'
                )
            );
        }
    };

    /* Limpa a flag de montagem ao sair da tela */
    componentWillUnmount() {
        this._isMounted = false;
    };

    /* Retorna a subclassificação padrão */
    getSubClassificacaoDefault = () => ({
        idsubclassifatendsac: '',
        idclassifatendimento: '',
        descsubclassificacao: '',
        inativo: ANAO
    });

    /* Carrega as classificações de atendimento */
    loadClassificacoes = async (idclassifatendimento) => {
        const url = idclassifatendimento
            ? `/classifatendimentosac/listforchange/${idclassifatendimento}`
            : '/classifatendimentosac/active/true';

        const response = await api.get(url);

        return getResponseData(response);
    };

    /* Carrega a subclassificação de atendimento */
    loadSubClassificacao = async (id, isView) => {
        const { history } = this.props;

        const response = await api.get(`/subclassifatendimentosac/${id}`);
        const registro = getRecordFromResponse(response);

        if (!registro) {
            this.handleOpenAlert('Subclassificação de atendimento não encontrada!');

            history.push('/crm/subclassifatendimentosac');

            return;
        }

        const classificacoes = await this.loadClassificacoes(registro.idclassifatendimento);

        this.safeSetState({
            subclassificacao: {
                idsubclassifatendsac: registro.idsubclassifatendsac || '',
                idclassifatendimento: registro.idclassifatendimento || '',
                descsubclassificacao: registro.descsubclassificacao || '',
                inativo: registro.inativo || ANAO
            },
            classificacoes,
            isNewRecord: false,
            isView
        });
    };

    /* Evento onChange componentes */
    onChange = (event) => {
        const { name, type, value, checked } = event.target;

        const adjustedValue = type === 'checkbox' ? (checked ? ANAO : ASIM) : value.toUpperCase();

        this.setState(prevState => ({
            subclassificacao: {
                ...prevState.subclassificacao,
                [name]: adjustedValue
            }
        }));
    };

    /* Abre a janela de alerta com mensagem */
    handleOpenAlert = (message) => {
        this.safeSetState({
            openAlert: true,
            messageAlert: message
        });
    };

    /* Fecha a janela de mensagem alerta */
    handleCloseAlert = () => {
        this.setState({ openAlert: false });
    };

    /* Retorna o payload de subclassificação de atendimento */
    getPayloadSubClassificacao = () => {
        const { subclassificacao } = this.state;

        return {
            idclassifatendimento: subclassificacao.idclassifatendimento || '',
            descsubclassificacao: subclassificacao.descsubclassificacao || '',
            inativo: subclassificacao.inativo || ANAO
        };
    };

    /* Clicar para salvar */
    onClickSave = async () => {
        const { subclassificacao, isNewRecord } = this.state;
        const { history, loadSubClassificacao } = this.props;

        const errors = this.validationRequiredFields();
        this.setState({ errors });

        if (Object.keys(errors).length > 0) {
            this.handleOpenAlert('Verifique os campos obrigatórios!');

            return;
        }

        if (!subclassificacao.idclassifatendimento || subclassificacao.idclassifatendimento === '0') {
            this.handleOpenAlert('Selecione a classificação!');

            return;
        }

        try {
            const payload = this.getPayloadSubClassificacao();

            if (isNewRecord) {
                await api.post('/subclassifatendimentosac', payload);
            } else {
                await api.put(
                    `/subclassifatendimentosac/${subclassificacao.idsubclassifatendsac}`, payload
                );
            }

            if (loadSubClassificacao) loadSubClassificacao();

            history.push('/crm/subclassifatendimentosac');
        } catch (error) {
            console.error('Erro ao salvar:', error.response?.data || error.message);

            this.handleOpenAlert(
                getApiErrorMessage(
                    error,
                    'Erro ao salvar!'
                )
            );
        }
    };

    /* Clicar para cancelar */
    onClickCancel = () => {
        this.props.history.push('/crm/subclassifatendimentosac');
    };

    /* Valida os campos obrigatórios ao salvar */
    validationRequiredFields() {
        const { subclassificacao, schema } = this.state;

        return validateSchemaFields(
            subclassificacao,
            schema,
            ['descsubclassificacao']
        );
    };

    render() {
        const {
            classificacoes,
            errors,
            isView,
            messageAlert,
            openAlert,
            subclassificacao
        } = this.state;

        return (
            <div>
                <CardContent>
                    <Box
                        display="flex"
                        alignItems="center"
                        justifyContent="space-between"
                        style={{ flexWrap: 'wrap' }}
                    >
                        <Typography
                            component="h1"
                            variant="h3"
                        >
                            Subclassificação de atendimento {subclassificacao.idsubclassifatendsac}
                        </Typography>

                        <FormStatusSwitch
                            checked={subclassificacao.inativo !== ASIM}
                            name="inativo"
                            onChange={this.onChange}
                            disabled={isView}
                        />
                    </Box>

                    <br />

                    <Box
                        display="flex"
                        style={{ gap: 12 }}
                    >
                        <TextField
                            label="Descrição"
                            name="descsubclassificacao"
                            value={subclassificacao.descsubclassificacao || ''}
                            variant="outlined"
                            onChange={this.onChange}
                            helperText={errors.descsubclassificacao || ''}
                            error={!!errors.descsubclassificacao}
                            disabled={isView}
                            inputProps={{ maxLength: 100 }}
                            style={{ flex: 1 }}
                        />

                        <FormControl
                            variant="outlined"
                            disabled={isView}
                            style={{ flex: 1 }}
                        >
                            <ComboPadrao
                                name={'idclassifatendimento'}
                                label={'Classificação'}
                                value={subclassificacao.idclassifatendimento}
                                onChange={this.onChange}
                                fieldId={'idclassifatendimento'}
                                listItems={classificacoes}
                                fieldDescription={'descclassificacao'}
                            />
                        </FormControl>
                    </Box>

                    <br />
                    <br />

                    <FormActions
                        onSave={this.onClickSave}
                        onCancel={this.onClickCancel}
                        disableSave={isView}
                    />
                </CardContent>

                <AlertInformation
                    open={openAlert}
                    message={messageAlert}
                    handleClose={this.handleCloseAlert}
                />
            </div>
        );
    }
};

SubclassificacaoForm.propTypes = {
    history: PropTypes.object,
    match: PropTypes.object,
    location: PropTypes.object,
    loadSubClassificacao: PropTypes.func
};

export default SubclassificacaoForm;